import SectionHeading from "../../../../../../../shared/components/ui/SectionHeading/SectionHeading";
import ClinicActions from "../ClinicActions/ClinicActions";

export default function ClinicContent({ content }) {
  const descriptionParts = content.descriptionStrong
    ? content.description.split(content.descriptionStrong)
    : null;

  const description = descriptionParts ? (
    <>
      {descriptionParts[0]}
      <strong>{content.descriptionStrong}</strong>
      {descriptionParts[1]}
    </>
  ) : (
    content.description
  );

  return (
    <div className="clinic-section__content">
      <div className="reveal-on-scroll reveal-on-scroll--up reveal-delay-1">
        <SectionHeading
          eyebrow={content.eyebrow}
          title={content.title}
          description={description}
          align="left"
          className="clinic-section__heading"
        />
      </div>

      <div className="clinic-section__title-line reveal-on-scroll reveal-on-scroll--right reveal-delay-2" />

      <ClinicActions content={content} />
    </div>
  );
}